import * as z from "zod";

const schema = z.object({
	id: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const VisitHistoryCreateResModel = {schema, model};
export type IVisitHistoryCreateResModel = z.infer<typeof VisitHistoryCreateResModel.model>;

export const DEFAULT_VISIT_HISTORY_CREATE_RES: IVisitHistoryCreateResModel = {
	id: ""
};
